import axios from 'axios'
import { metricUrl, IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

//查询电子围栏详细信息,拿到工作场所
export function getfenceName(params) {
  const url = metricUrl + '/geofence/message'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '查询电子围栏详情信息', res)
    }
    return Promise.resolve(res.data)
  })
}
//查询考勤记录详情
export function getAttendanceDetail(params) {
  const url = IhLogUrl + '/work/record/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '查询考情记录详情', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出考勤记录
export function getExportAttendance(params) {
  const url = IhLogUrl + '/work/record/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('告警信息', '导出考勤记录', res)
    }
    return Promise.resolve(res.data)
  })
}
